import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { getStepContent } from './stepContent'
import { steps } from '../../constants/steps';
import useFormStepper from './useFormStepper';
import ButtonContainer from '../ButtonContainer/ButtonContainer';
import Shimmer from '../Shimmer/Shimmer';

export default function FormStepper() {

  const { 
    activeStep, 
    btnAction, 
    appState, 
    dataLoaded , 
    setActiveStep , 
    stepperClickable,
    signCanOverwrite,
    agentRestricted
  } = useFormStepper();
  
  return (
    <>
      {dataLoaded ?
        <Box sx={{ width: '100%', height: { xs: '100%', md: '100%' } }} >
          <Stepper
            activeStep={activeStep}
            sx={{
              pt: 3, pb: 5,
              '& .MuiStepIcon-root.Mui-completed': { color: 'success.main' },
              '& .MuiStepLabel-label.Mui-active': { fontWeight: "bolder", fontSize: '15px', textTransform: 'uppercase' },

            }}
            alternativeLabel
          >
            {activeStep !== 2 && 
              (!agentRestricted) && steps.map((label , key) => {
                  const stepProps = {};
                  const labelProps = {};
                  
                  return (
                    <Step 
                    key={label} 
                    {...stepProps} 
                    >
                      <StepLabel {...labelProps} >{label}</StepLabel>
                    </Step>
                  );
            })}
          </Stepper>
          <ButtonContainer
            btnAction={btnAction}
            activeStep={activeStep}
            steps={steps}
            getStepContent={() => getStepContent(activeStep, signCanOverwrite , agentRestricted)}
            action={appState.formInfo.action}
            formStatus={appState.formInfo.status}
            isAgentRestricted={agentRestricted}
          />
        </Box>
        :
        <Shimmer />
      }
    </>

  );
}